// components/DriversSection.jsx
import React from "react";
import group from "../../assets/group.webp";
import DriverBlock from "./DriverBlock";

const DriversSection = () => {
  const blocks = [
    {
      title: "EMPOWERING BUSINESSES",
      icon: group,
      content:
        "We are dedicated to providing businesses with cutting-edge IT solutions that enhance efficiency, scalability, and security. Our goal is to empower organizations to focus on their core strengths while we handle their IT needs seamlessly.",
    },
    {
      title: "BRIDGING TECHNOLOGY GAPS",
      icon: group,
      content:
        "Multify was established to address the lack of robust IT infrastructure in underserved regions like Central India. By introducing world-class data centers and cloud services, we are closing the gap and enabling businesses to access the tools they need to thrive.",
    },
    {
      title: "CUSTOMER-CENTRIC APPROACH",
      icon: group,
      content:
        "At Multify, our customers are at the heart of everything we do. We strive to understand their unique challenges and design customized solutions that meet their specific needs. Their success is our success.",
    },
    {
      title: "COMMITMENT TO SECURITY AND RESILIENCE",
      icon: group,
      content:
        "In today's digital age, safeguarding data is paramount. We prioritize security and resilience, ensuring that our clients' critical data and operations are protected at all times.",
    },
  ];

  return (
    <>
      <h2 className="text-3xl md:text-4xl font-bold text-white text-left pt-10">
        What drives Multify?
      </h2>
      <p className="text-base md:text-lg text-left text-gray-300 mb-8 md:mb-16 pt-5 md:pt-10">
        At Multify, our journey is fueled by a passion for innovation, a
        commitment to excellence, and a vision to transform the IT landscape of
        Central India. Here's what drives us:
      </p>
      <div className="grid grid-cols-1 md:grid-cols-2 gap-6 md:gap-8 text-white">
        {blocks.map((block, index) => (
          <DriverBlock key={index} block={block} />
        ))}
      </div>
    </>
  );
};

export default DriversSection;
